import { render, staticRenderFns } from "./CloseMobilePanelButton.vue?vue&type=template&id=cc20a05c&scoped=true"
import script from "./CloseMobilePanelButton.vue?vue&type=script&lang=js"
export * from "./CloseMobilePanelButton.vue?vue&type=script&lang=js"
import style0 from "./CloseMobilePanelButton.vue?vue&type=style&index=0&id=cc20a05c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc20a05c",
  null
  
)

export default component.exports